<template>
  <div class="calendar-container" style="margin-top: -15px;">
    <div class="d-flex align-stretch bg-color">
      <div class="left-side pa-2">
        <div class="d-flex justify-between mt-2 mr-4" v-if="!searchBarShow">
          <div class="font-16 font-bold color">
            我的课程
          </div>
          <a-icon v-if="!searchBarShow" @click="handleSearchIcon" class="font-16 btn-wrapper" type="search" />
        </div>
        <div v-if="searchBarShow" class="mt-2">
          <div class="d-flex">
            <div class="flex-1">
              <a-input-search style="width:220px" v-model="searchValue" @change="handleSearch" @pressEnter="handleSearch" placeholder="请输入搜索内容" :border="false"></a-input-search>
            </div>
            <div class="rowLine"></div>
            <div @click="cancelSearch" class="cancel-btn btn-wrapper ml-1">取消</div>
          </div>
          <div class="line"></div>
          <!-- <div class="search bar4">
            <form>
              <input type="text" placeholder="请输入您要搜索的内容...">
              <button type="submit"></button>
            </form>
          </div> -->
          <div>
            <div class="my-2" style="max-height: 660px; overflow-y: auto;">
              <a-checkbox-group v-show="(groupOptions.length > 0)" style="width:260px" v-model="groupOptionsCheckKeys" :options="groupOptions">
              </a-checkbox-group>
            </div>
            <div v-if="groupOptions.length > 0" class="d-flex justify-between">
              <a-checkbox style="width:260px" v-model="groupOptionsAllCheck" @change="groupOptionAllCheckChange">全选
              </a-checkbox>
              <div @click="confirmCheck" class="confirm-btn btn-wrapper" style="color:#4B7DFD;font-size:12px;">
                确定
              </div>
            </div>
            <div style="text-align: center;
font-size: 12px;
color: #84878D;" v-else-if="(clickSearchBtn && groupOptions.length === 0)">
              暂无直播课程哦~
            </div>
          </div>
        </div>
        <div v-if="confirmShow && !searchBarShow" class="mt-2">
          <div class="my-2" style="max-height: 700px;overflow-y: auto;">
            <a-checkbox-group style="width:260px" v-model="groupOptionsCheckKeys" :options="groupOptions">
            </a-checkbox-group>
          </div>
          <div class="d-flex justify-between">
            <div class="cancel-btn">当前选中</div>
            <div @click="confirmBack" class="confirm-btn btn-wrapper">返回</div>
          </div>
        </div>
        <div v-if="!searchBarShow && !confirmShow" class="mt-2">
          <a-checkbox style="width:260px" v-model="allClassCheck" @change="allClassCheckChange">
            全选</a-checkbox>
          <div style="max-height: 700px;overflow-y: auto;">
            <a-checkbox-group v-model="checkKeys" :options="allClassesSecondData"></a-checkbox-group>
          </div>
        </div>
      </div>
      <div class="flex-1 pa-2" style="background:#fff;border-radius:10px;width:874px;">
        <a-spin :spinning="loading">
          <a-calendar v-model="dateValue" mode="month">
            <div class="calendar-fullCell" slot="dateFullCellRender" slot-scope="value">
              <div class="calendar-date">
                {{ formatterDate(value) }}
              </div>
              <ul class="events">
                <!-- 小于等于日历限制显示数量情况 -->
                <template v-if="getListData(value).length <= calendarLimit">
                  <a-popover placement="rightTop" v-for="item in getListData(value)" :key="item.id" trigger="click" @click="showMoreCourse = false" v-model="popoverShow[item.uniqueId]">
                    <template slot="content">
                      <div style="width:300px">
                        <div class="d-flex justify-end ">
                          <a-icon @click="popoverShow[item.uniqueId] = false" class="font-12 btn-wrapper" type="close">
                          </a-icon>
                        </div>
                        <div class="font-16 font-bold mb-2 text-cut">{{ item.classesName }}</div>
                        <div class="text-color mb-2 text-cut">
                          {{ item.scheduleName }}
                        </div>
                        <div class="text-color mb-2">{{ item.startTime }}-{{ item.endTime }}</div>
                        <div class="d-flex justify-between">
                          <div class="d-flex">
                            <div class="avatar mr-1">
                              <img class="lecturer-avatar" v-if="transformUrl(item.lecturerPhoto)" :src="transformUrl(item.lecturerPhoto)" alt="" />
                              <div v-else style="width: 100%; height: 100%; background-color: #D8D8D8;"></div>
                            </div>
                            <div class="text-color">{{ item.lecturerName }}</div>
                          </div>
                          <div>
                            <a-button @click="goToLivePlay(item)" key="1" v-if="item.liveStatus == 1" class="living" type="primary" shape="round">
                              <div class="d-flex">
                                直播中
                                <img class="living-icon ml-1" :src="livingIcon" alt="" />
                              </div>
                            </a-button>
                            <a-button @click="goToLivePlay(item)" key="2" v-if="item.liveStatus == 2" type="primary" shape="round" class="replay-video-btn">观看回放</a-button>
                            <a-button key="0" @click="handleNoStart" v-if="item.liveStatus == 0" type="default" shape="round" class="overdue-course">
                              未开始</a-button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <li :class="activeTip === item.uniqueId ? 'active' : ''" class="live-item mb-1 text-cut" @click="activeTips(item)">
                      {{ item.scheduleName }}
                    </li>
                  </a-popover>
                </template>
                <!-- 超出日历限制显示数量情况 -->
                <template v-if="getListData(value).length > calendarLimit">
                  <!-- 顺序显示部分 -->
                  <a-popover placement="rightTop" v-for="item in getListData(value).slice(0, calendarLimit)" :key="item.id" @click="showMoreCourse = false" trigger="click" v-model="popoverShow[item.uniqueId]">
                    <template slot="content">
                      <div style="width:300px">
                        <div class="d-flex justify-end">
                          <a-icon @click="popoverShow[item.uniqueId] = false" class="font-12 btn-wrapper" type="close">
                          </a-icon>
                        </div>
                        <div class="font-16 font-bold mb-2 text-cut">{{ item.classesName }}</div>
                        <div class="text-color mb-2 text-cut">
                          {{ item.scheduleName }}
                        </div>
                        <div class="text-color mb-2">{{ item.startTime }}-{{ item.endTime }}</div>
                        <div class="d-flex justify-between">
                          <div class="d-flex">
                            <div class="avatar mr-1">
                              <img class="lecturer-avatar" v-if="transformUrl(item.lecturerPhoto)" :src="transformUrl(item.lecturerPhoto)" alt="" />
                              <div v-else style="width: 100%; height: 100%; background-color: #D8D8D8;"></div>
                            </div>
                            <div class="text-color">{{ item.lecturerName }}</div>
                          </div>
                          <div>
                            <a-button @click="goToLivePlay(item)" key="1" v-if="item.liveStatus == 1" type="primary" shape="round" class="living">
                              <div class="d-flex">
                                直播中
                                <img class="living-icon ml-1" :src="livingIcon" alt="" />
                              </div>
                            </a-button>
                            <a-button @click="goToLivePlay(item)" key="2" v-if="item.liveStatus == 2" type="primary" shape="round" class="replay-video-btn">观看回放</a-button>
                            <a-button key="0" @click="handleNoStart" v-if="item.liveStatus == 0" type="default" shape="round" class="overdue-course">
                              未开始</a-button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <li :class="activeTip === item.uniqueId ? 'active' : ''" class="live-item mb-1 text-cut" @click="activeTips(item)">
                      {{ item.scheduleName }}
                    </li>
                  </a-popover>
                  <!-- 总览部分 -->
                  <a-popover :overlayClassName="'more-box'" class="more-popover" placement="rightTop" :visible="showMoreCourse === new Date(value).getTime()">
                    <template slot="content">
                      <div style="width: 270px">
                        <div class="d-flex justify-between " style="padding: 8px 16px; border-bottom: 1px solid #F4F6F7; align-items: center;">
                          <div style="font-size: 14px;font-weight: bold;color: #303133; ">
                            当日直播
                          </div>
                          <a-icon @click="showMoreCourse = false" class="font-12 btn-wrapper" type="close"> </a-icon>
                        </div>
                        <ul class="moreUl" style="max-height: 400px; overflow-y: auto;">
                          <a-popover placement="rightTop" v-for="item in getListData(value)" :key="item.scheduleId" trigger="click" :visible="moreCourseByClick === item.scheduleId">
                            <template slot="content">
                              <div style="width:300px">
                                <div class="d-flex justify-end ">
                                  <a-icon @click="moreCourseByClick = null" class="font-12 btn-wrapper" type="close">
                                  </a-icon>
                                </div>
                                <div class="font-16 font-bold mb-2 text-cut" style="color: #303133; font-size: 16px;">
                                  {{ item.classesName }}
                                </div>
                                <div class="text-color mb-2" style="color: #303133; font-size: 14px;">
                                  {{ item.startTime }}-{{ item.endTime }}
                                </div>

                                <div class="text-color mb-2 text-cut" style="font-size: 12px;color: #84878D;">
                                  {{ item.scheduleName }}
                                </div>
                                <div class="d-flex justify-between">
                                  <div class="d-flex">
                                    <div class="avatar mr-1">
                                      <img class="lecturer-avatar" v-if="transformUrl(item.lecturerPhoto)" :src="transformUrl(item.lecturerPhoto)" alt="" />
                                      <div v-else style="width: 100%; height: 100%; background-color: #D8D8D8;"></div>
                                    </div>
                                    <div class="text-color">{{ item.lecturerName }}</div>
                                  </div>
                                  <div>
                                    <a-button @click="goToLivePlay(item)" key="1" v-if="item.liveStatus == 1" type="primary" shape="round" class="living">
                                      <div class="d-flex">
                                        直播中
                                        <img class="living-icon ml-1" :src="livingIcon" alt="" />
                                      </div>
                                    </a-button>
                                    <a-button @click="goToLivePlay(item)" key="2" v-if="item.liveStatus == 2" type="primary" shape="round" class="replay-video-btn">观看回放</a-button>
                                    <a-button key="0" @click="handleNoStart" v-if="item.liveStatus == 0" type="default" shape="round" class="overdue-course">
                                      未开始</a-button>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <li class="moreCourse-item" :class="moreCourseByClick === item.scheduleId ? 'active' : ''" @click="moreCourseByClick = item.scheduleId">
                              {{ item.id }}
                              <div class="course-title">
                                {{ item.scheduleName }}
                              </div>
                              <div class="course-time">{{ item.startTime }}-{{ item.endTime }}</div>
                            </li>
                          </a-popover>
                        </ul>
                      </div>
                    </template>
                    <div @click="showAllCourse(value)" class="live-item mb-1 text-cut" :class="showMoreCourse === new Date(value).getTime() ? 'active' : ''" :title="`当日共${getListData(value).length}课次`">
                      当日共
                      <span class="lesson-count" :style="showMoreCourse === new Date(value).getTime() ? { color: '#fff' } : {}">{{
                        getListData(value).length
                      }}课次</span>
                    </div>
                  </a-popover>
                </template>
              </ul>
            </div>

            <div slot="headerRender" class="d-flex mb-2">
              <div class="font-26 text-bold mr-3 ml-2 color">
                {{ nowTime }}
              </div>
              <div class="d-flex btn-wrapper">
                <div @click="handlePrevMonth" class="prev-btn d-flex justify-center btn">
                  <a-icon type="left"></a-icon>
                </div>
                <div @click="handleThisMonth" class="today-btn text-center btn">今天</div>
                <div @click="handleNextMonth" class="next-btn d-flex justify-center btn">
                  <a-icon type="right"></a-icon>
                </div>
              </div>
            </div>
          </a-calendar>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getLiveCalendar, getLiveClassesInfo } from '@/api/live'
import _ from 'lodash'
import { goToLivePlayer } from '@/utils/livePlay'
import livingIcon from '@/assets/icons/living.gif'
import { transformUrl } from '@/utils/util'
export default {
  name: 'LivePage',
  props: {},
  data() {
    return {
      livingIcon,
      loading: true,
      confirmShow: false,
      searchBarShow: false,
      searchValue: '',
      activeTip: '',
      allClassesData: [], // 所有班级
      allClassesSecondData: [], // 所有班级下的所有课程
      checkKeys: [], // 选中的课程
      checkallClassesKeys: [],
      popoverShow: {},
      nowTime: '',
      dateValue: '',
      groupOptions: [],
      groupOptionsCheckKeys: [],
      groupOptionsAllCheck: false,
      allClassCheck: true,
      allLength: 0,
      liveCalendarData: [],
      calendarLimit: 2, // 日历展示条目限制
      showMoreCourse: false,
      moreCourseByClick: null,
      clickSearchBtn: false // 初始化未点击搜索
    }
  },
  components: {},
  computed: {
    checkGroupOptions() {
      return this.groupOptions.filter(item => {
        return this.groupOptionsCheckKeys.includes(item.value)
      })
    }
  },
  created() {
    this.getDate()
    this.getClassInfo()
  },
  mounted() { },
  watch: {
    showMoreCourse(val) {
      if (!val) {
        this.moreCourseByClick = null
      }
    },
    checkKeys(v) {
      this.allClassCheck = this.allClassesSecondData.length === v.length
      this.getLiveCalendarData(v, 2)
    },
    groupOptionsCheckKeys(v) {
      // console.log('v', v)
      this.groupOptionsAllCheck = v.length === this.groupOptions.length
      if (this.confirmShow) {
        if (v.length === 0) {
          this.confirack()
        }
      }
      this.fetchCalendarData()
    }
  },
  methods: {
    showAllCourse(value) {
      this.popoverShow = {}
      this.activeTip = ''
      this.moreCourseByClick = null
      this.showMoreCourse = new Date(value).getTime()
    },
    transformUrl,
    goToLivePlay(item) {
      // console.log(item)
      goToLivePlayer(item.scheduleId, item.planclassesId)
    },
    handleSearchIcon() {
      this.searchBarShow = true
      this.confirmShow = false
    },
    /**
     * 格式化标准时间
     */
    formatterDate(GMTDate) {
      const date = new Date(GMTDate)
      return date.getDate()
    },
    getDate() {
      const queryDate = this.$route.query.date
      if (queryDate) {
        this.nowTime = moment(queryDate).format('YYYY年MM月')
        this.dateValue = moment(queryDate)
      } else {
        this.nowTime = moment().format('YYYY年MM月')
        this.dateValue = moment()
      }
    },
    getLiveCalendarData(keys, type) {
      // console.log('keys', keys)
      // console.log('type', type)
      this.loading = true
      const time = moment(this.dateValue).format('YYYY-MM')
      keys = keys.filter(item => item)
      // console.log('keys', keys)
      if (type === 1) {
        keys = [keys.join(',')][0].split(',')
        // console.log('keys', keys[0].split(','))
      } else if (type === 2) {
        keys = keys.filter(item => item.includes(',')).map(item => item.split(',')[1])
      } else {
        keys = keys
          .filter(v => this.checkallClassesKeys.includes(v))
          .map(item => {
            return item.split(',')[1]
          })
      }
      // if (type === 2) {
      //   keys = keys.filter(v => this.checkallClassesKeys.includes(v)).map(item => {
      //     return item.split(',')[1]
      //   })
      // }
      getLiveCalendar({
        classesIds: keys,
        time
      })
        .then(res => {
          if (res) {
            this.liveCalendarData = res.map(item => {
              this.$set(this.popoverShow, item.liveTimeStar + item.classesId, false)
              return {
                ...item,
                uniqueId: item.liveTimeStar + item.liveTimeEnd + item.classesId,
                startTime: moment(item.liveTimeStar).format('HH:mm'),
                endTime: moment(item.liveTimeEnd).format('HH:mm')
              }
            })
          } else {
            this.$set(this, 'popoverShow', {})
            this.$set(this, 'liveCalendarData', [])
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 页面跳转默认选中上个页面的课程列表
    checkPlanclasses() {
      const ary = []
      const ary2 = []
      const { planclassesId } = this.$route.query
      this.allClassesData.forEach(item => {
        if (item.key === planclassesId) {
          // item.key && ary.push(item.key)
          item.studentClassesList.forEach(v => {
            ary.push(item.planclassesId + ',' + v.classesId)
            ary2.push(item.planclassesId + ',' + v.classesId)
          })
        }
      })
      this.$set(this, 'checkKeys', ary)
      this.$set(this, 'checkallClassesKeys', ary2)
    },
    // 公开课
    chcekOpenClasses() {
      const ary = []
      const ary2 = []
      const { classesId } = this.$route.query
      const data = this.allClassesData.filter(item => !item.planclassesId)
      // console.log('data', data)
      ary.push(null)
      data[0].studentClassesList.forEach(item => {
        if (item.classesId === classesId) {
          ary.push(null + ',' + item.classesId)
          ary2.push(null + ',' + item.classesId)
        }
      })
      this.$set(this, 'checkKeys', ary)
      this.$set(this, 'checkallClassesKeys', ary2)
      // this.allClassesData.forEach(item => {
      //   console.log('item', item)
      // })
    },
    checkallClasses() {
      const ary = []
      const ary2 = []
      // this.allClassesData.forEach(item => {
      //   item.key && ary.push(item.key)
      // })
      this.allClassesSecondData.forEach(item => {
        ary.push(item.value)
        ary2.push(item.value)
      })
      this.$set(this, 'checkKeys', ary)
      this.$set(this, 'checkallClassesKeys', ary2)
    },
    allClassCheckChange(e) {
      if (e.target.checked) {
        this.checkallClasses()
      } else {
        this.checkKeys = []
      }
    },
    confirmBack() {
      this.searchBarShow = false
      this.confirmShow = false
      this.searchValue = ''
      this.groupOptionsCheckKeys = []
      this.groupOptions = []
    },
    confirmCheck() {
      // console.log('this.groupOptionsCheckKeys', this.groupOptionsCheckKeys)
      if (this.groupOptionsCheckKeys.length > 0) {
        this.searchBarShow = false
        this.confirmShow = true
        this.fetchCalendarData()
      } else {
        this.$message.warning('请勾选课程')
      }
    },
    groupOptionAllCheckChange(e) {
      if (e.target.checked) {
        this.groupOptionsCheckKeys = this.groupOptions.map(item => item.value)
      } else {
        this.groupOptionsCheckKeys = []
      }
    },
    handleSearch: _.throttle(
      function () {
        this.clickSearchBtn = true
        this.groupOptionsCheckKeys = []
        // console.log('this.searchValue', this.searchValue)
        // console.log('this.allClassesSecondData', this.allClassesSecondData)
        // console.log('allClassesData', this.allClassesData)
        if (this.searchValue) {
          // this.groupOptions = this.allClassesSecondData.filter(item => {
          //   // return item.label.indexOf(this.searchValue) > -1
          //   return item.label.includes(this.searchValue)
          // })
          const secondData = this.allClassesSecondData.filter(item => item.label.includes(this.searchValue))
          const data = this.allClassesData.filter(item => {
            item.label = item.planclassesName
            const values = []
            item.studentClassesList.forEach(item => {
              values.push(item.classesId)
            })
            item.value = values.join(',')
            return item.label.includes(this.searchValue)
          })
          this.groupOptions = [...data, ...secondData]
        } else {
          this.groupOptions = []
        }
        // console.log('this.groupOptions', this.groupOptions)
      },
      500,
      { leading: false, trailing: true }
    ),
    cancelSearch() {
      this.searchBarShow = false
      this.confirmShow = false
      this.clickSearchBtn = false
      this.searchValue = ''
      this.groupOptions = []
      this.getLiveCalendarData(this.checkKeys, 2)
      // this.checkallClasses()
    },
    getClassInfo() {
      getLiveClassesInfo().then(res => {
        // console.log('res', res)
        if (res) {
          // 所有班级
          this.allClassesData = res.map((item, index) => {
            return {
              ...item,
              key: item.planclassesId
            }
          })
          const ary = []
          // 所有班级下的所有课程
          res.forEach(item => {
            item.studentClassesList.forEach(v => {
              ary.push({
                label: v.className,
                value: item.planclassesId + ',' + v.classesId
              })
            })
          })
          this.allClassesSecondData = ary
          this.allLength = this.allClassesSecondData.length
          // 页面跳转选中班级
          if (this.$route.query.planclassesId) {
            this.checkPlanclasses()
          } else if (this.$route.query.classesId) {
            this.chcekOpenClasses()
          } else {
            // 默认全选
            this.checkallClasses()
          }
        } else {
          this.allClassesData = []
          this.allClassesSecondData = []
          this.allLength = 0
        }
      })
    },
    activeTips(item) {
      // console.log('item', item.classesId)
      // console.log('item', item.classesId)
      this.activeTip = item.uniqueId
    },
    fetchCalendarData() {
      if (this.confirmShow || this.searchBarShow) {
        // console.log('1')
        this.getLiveCalendarData(this.groupOptionsCheckKeys, 1)
      } else {
        // console.log('fetchCalendarData', this.checkKeys)
        // this.getLiveCalendarData(this.checkallClassesKeys)
        this.getLiveCalendarData(this.checkKeys, 2)
      }
    },
    handlePrevMonth() {
      const value = moment(this.dateValue).subtract(1, 'months')
      this.nowTime = value.format('YYYY年MM月')
      this.dateValue = value
      this.fetchCalendarData()
      this.showMoreCourse = false
    },
    handleThisMonth() {
      const value = moment()
      this.nowTime = value.format('YYYY年MM月')
      this.dateValue = value
      this.fetchCalendarData()
      this.showMoreCourse = false
    },
    handleNextMonth() {
      const value = moment(this.dateValue).add(1, 'months')
      this.nowTime = value.format('YYYY年MM月')
      this.dateValue = value
      this.fetchCalendarData()
      this.showMoreCourse = false
    },
    getListData(value) {
      let listData = []
      listData = this.liveCalendarData.filter(item => {
        return moment(item.liveTimeStar).format('YYYY-MM-DD') === moment(value).format('YYYY-MM-DD')
      })
      // if (listData.length) {
      //   console.log('listData', moment(listData[0].liveTimeStar))
      //   console.log('this.dateValue', this.dateValue)
      // }
      // 0 未开始 1 直播中 2 回放
      // 先直播中 按时间正序
      // 未开始 时间正序
      // 回放
      // listData.forEach(item => {})
      const arr0 = []
      const arr1 = []
      const arr2 = []
      listData.forEach(item => {
        if (item.liveStatus === '0') {
          arr0.push(item)
        }
        if (item.liveStatus === '1') {
          arr1.push(item)
        }
        if (item.liveStatus === '2') {
          arr2.push(item)
        }
      })
      this.handleSort(arr0)
      this.handleSort(arr1)
      this.handleSort(arr2)
      return [...arr0, ...arr1, ...arr2]
    },
    handleSort(arr) {
      arr.sort((a, b) => {
        const startTimeA = moment(a.liveTimeStar).unix()
        const startTimeB = moment(b.liveTimeStar).unix()
        const endTimeA = moment(a.liveTimeEnd).unix()
        const endTimeB = moment(a.liveTimeEnd).unix()
        if (startTimeA === startTimeB) {
          return endTimeA - endTimeB
        } else {
          return startTimeA - startTimeB
        }
      })
    },
    handleNoStart() {
      this.$message.warning('直播还未开始')
    }
  }
}
</script>
<style lang="less">
.ant-popover.more-box {
  .ant-popover-content {
    .ant-popover-inner-content {
      padding: 0;
    }
  }
}
</style>
<style scoped lang="less">
.overdue-course {
  width: 82px;
  height: 32px;
  background: #D6D7D8 !important;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.replay-video-btn {
  width: 82px;
  height: 32px;
  background: #4B7DFD !important;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.living {
  background: #ff5a4f !important;
  color: #fff;
  border: 1px solid #ff5a4f
}

.ant-fullcalendar-selected-day {
  .calendar-fullCell {
    .calendar-date {
      color: #4B7DFD;
    }
  }

  .calendar-fullCell.fullBlue {
    background: #4b7dfd;

    .live-item {
      color: #fff;

      .lesson-count {
        color: #fff;
      }
    }
  }
}

.ant-fullcalendar-next-month-btn-day,
.ant-fullcalendar-last-month-cell {
  .calendar-fullCell {
    .calendar-date {
      color: #9ea1a6;
    }
  }
}

.calendar-fullCell {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  // box-sizing: border-box;
  padding: 8px 0 8px 8px;
  cursor: pointer;
  height: 106px !important;
  margin: 0;
  border-top: 1px solid #eef0f4;
  transition: all 0.2s;

  .calendar-date {
    font-size: 16px;
    font-weight: bold;
    color: #303133;

    .events {
      height: 100%;
      overflow: hidden;
      list-style: none;
      margin: 0;
      padding: 0;

      .ant-badge-status {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        text-overflow: ellipsis;
        font-size: 12px;
      }
    }
  }
}

.more-box {
  .moreUl {
    overflow-x: hidden;

    &::-webkit-scrollbar {
      display: block;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.48);
    }
  }

  .moreCourse-item {
    box-sizing: border-box;
    padding: 14px 12px;
    background: #fff;
    height: 71px;
    transition: all 0.2s;

    .course-title {
      width: 270px;
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 6px;
    }

    .course-time {
      font-size: 12px;
      font-weight: 400;
      color: #7b7d80;
    }

    &.active {
      background: #f2f6ff;

      .course-title,
      .course-time {
        color: #4b7dfd;
      }
    }
  }
}

::v-deep .ant-checkbox {
  border-radius: 50%;
  overflow: hidden;
}

::v-deep .ant-checkbox-inner {
  border-radius: 50%;
}

::v-deep .ant-input {
  border-radius: 50px;
  overflow: hidden;
}

.cancel-btn {
  color: #84878d;
  font-size: 12px;
  margin-right: 22px;
}

.confirm-btn {
  color: #1564ff;
}

.text-color {
  color: #5e668d;
}

::v-deep .ant-tree li span.ant-tree-switcher,
.ant-tree li span.ant-tree-iconEle {
  display: none !important;
}

::v-deep .ant-btn-default {
  background-color: #f5f6fa;
}

::v-deep .ant-checkbox-group-item {
  display: block;
}

::v-deep .ant-tree.ant-tree-directory>li.ant-tree-treenode-selected>span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner,
::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree>li.ant-tree-treenode-selected>span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background-color: #1890ff;
}

::v-deep .ant-tree.ant-tree-directory>li.ant-tree-treenode-selected>span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after,
::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree>li.ant-tree-treenode-selected>span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
  border-color: #fff;
}

::v-deep .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper.ant-tree-node-selected,
.ant-tree.ant-tree-directory .ant-tree-child-tree>li span.ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: rgba(0, 0, 0, 0.65);
}

::v-deep .ant-tree.ant-tree-directory>li.ant-tree-treenode-selected>span.ant-tree-node-content-wrapper::before,
::v-deep .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-close::before {
  background-color: #f5f6fa;
  padding: 5px;
}

::v-deep .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-open::before {
  background-color: #f5f6fa;
  padding: 5px;
}

::v-deep .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper::before {
  // background-color: transparent;
  border-radius: 10px;
}

::v-deep .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper:hover,
.ant-tree.ant-tree-directory .ant-tree-child-tree>li span.ant-tree-node-content-wrapper:hover {
  background-color: transparent;
}

::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree>li.ant-tree-treenode-selected>span.ant-tree-node-content-wrapper::before {
  background-color: #fff;
}

::v-deep .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper-normal:hover::before {
  background-color: transparent;
}

::v-deep .ant-tree-node-content-wrapper {
  border-radius: 10px;
}

::v-deep .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
  border-radius: 50%;
}

::v-deep .ant-tree-checkbox-checked::after {
  border-radius: 50%;
}

::v-deep .ant-tree-checkbox {
  border-radius: 50%;
  overflow: hidden;
}

::v-deep .ant-tree-checkbox-inner {
  border-radius: 50%;
}

::v-deep .ant-fullcalendar-fullscreen .ant-fullcalendar-date:active {
  background-color: #fff;
}

::v-deep .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {
  background-color: #fff;
}

::v-deep.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value,
::v-deep .ant-fullcalendar-fullscreen .ant-fullcalendar-value {
  font-weight: bold;
  font-size: 16px;
}

.tree-title {
  width: 170px;
}

.bg-color {
  border-radius: 20px;
  background: #f5f8fa;
}

.left-side {
  width: 304px;
  background: #fff;
  margin-right: 22px;
  border-radius: 10px;
  // border-right: 1px solid #ced3dc;
}

/deep/ .ant-checkbox-group-item {
  display: block;
  margin-top: 16px;
}

.expand-icon {
  transition: 0.5s;
}

.expanded {
  transform: rotate(180deg);
}

.live-item {
  // background-color: #f5f6fa;
  border-radius: 4px;
  font-size: 12px;

  .lesson-count {
    font-weight: 500;
    color: #4b7dfd;
  }
}

.active {
  color: #ffffff;
  background: #4b7dfd;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  // background-color: #D8D8D8;

  .lecturer-avatar {
    width: 100%;
    height: 100%;
    // background-color: #D8D8D8;
  }
}

.today-btn {
  width: 50px;
  line-height: 24px;
  height: 24px;
  margin: 0 8px;
  border: 1px solid #ced3dc;
  user-select: none;
  border-radius: 4px;
  font-size: 12px;
  color: #303133;
}

.prev-btn {
  width: 30px;
  height: 24px;
  border: 1px solid #ced3dc;
  border-radius: 4px;
}

.next-btn {
  width: 30px;
  height: 24px;
  border: 1px solid #ced3dc;
  border-radius: 4px;
}

.btn {
  &:active {
    position: relative;
    top: 1px;
  }
}

.btn-wrapper {
  cursor: pointer;
}

.living-icon {
  width: 10px;
  height: 10px;
}

.color {
  color: #303133;
  font-weight: bold;
}

.ant-fullcalendar-value {
  color: #303133;
}

/deep/ .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
  height: 106px !important;
  margin: 0;
  border-top: 1px solid #eef0f4;
}

/deep/ .ant-fullcalendar-calendar-body {
  padding-top: 20px;
}

/deep/ .ant-fullcalendar-fullscreen .ant-fullcalendar-column-header {
  padding-right: 12px;
  padding-bottom: 5px;
  text-align: center;
}

/deep/ .ant-fullcalendar-fullscreen .ant-fullcalendar-value {
  width: auto;
  text-align: left;
  background: transparent;
}

/deep/ .ant-checkbox+span {
  padding-right: 8px;
  padding-left: 8px;
  color: #303133;
  font-size: 12px;
}

/deep/ .ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 14px;
  height: 14px;
  // background-color: #fff;
  border: none;
  // border-radius: 2px;
  border-collapse: separate;
  // -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/deep/ .ant-checkbox-group {
  width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  // -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum';
  display: inline-block;
}

/deep/ .ant-fullcalendar-content {
  height: 74px;
}

input {
  border: 1px solid #d2d2d2;
  background-color: transparent;
}

.line {
  width: 100%;
  border-bottom: 1px solid #eaecf1;
  margin-top: 10px;
}

/deep/ .ant-input-affix-wrapper .ant-input {
  position: relative;
  text-align: inherit;
  border: 0;
}

/deep/ .rowLine {
  width: 1px;
  height: 24px;
  background: #eaecf1;
  margin-right: 10px;
}

/deep/.ant-input:focus {
  border: none;
  box-shadow: none;
}

/deep/ .ant-checkbox-group-item {
  display: block;
  margin-top: 16px;
  overflow: hidden;
  width: 250px;
  text-overflow: ellipsis;
}
</style>
